import { expandAndFocusField } from 'purchase/checkout/formOptionalFields';

const getReasonFromUrl = () => {
	const params = new URLSearchParams(window.location.search);
	const reason = params.get('reason');
	return reason ? reason.trim() : '';
};

const findPostalCodeField = () =>
	// Prefer the lookup postal code input (Experian flow), fallback to manual postal code input
	document.querySelector(
		'.js-address-search-input.js-validate-postal-code-input',
	) ||
	document.querySelector('.js-address-postal-code') ||
	document.querySelector('input[name="postalCode"]') ||
	document.querySelector('input#postalCode');

const findAddress1Field = () =>
	document.querySelector('.js-address-line-1') ||
	document.querySelector('input[name="line1"]') ||
	document.querySelector('input#line1') ||
	document.querySelector('input#address1');

const findTownField = () =>
	document.querySelector('.js-address-city') ||
	document.querySelector('input[name="town"]') ||
	document.querySelector('input#town');

const findFormRowForField = field =>
	field.closest('.js-address-form-row') ||
	field.closest('.form-inline-row') ||
	field.closest('.form-group') ||
	null;

const highlightUsingExistingStyles = (field, formRow) => {
	field.classList.add('invalid', 'is-invalid');

	if (formRow) {
		formRow.classList.add('has-error');
	}

	field.dispatchEvent(new Event('focus', { bubbles: true }));
	field.dispatchEvent(new Event('blur', { bubbles: true }));
};

const REASON_FIELD_MAP = {
	postalCode: findPostalCodeField,
	address1: findAddress1Field,
	town: findTownField,
};

export default function highlightFieldFromReason() {
	if (typeof window === 'undefined') return;

	const reason = getReasonFromUrl();
	if (!reason) return;

	// Split by comma to handle multiple reasons (e.g., "address1,postalCode,town")
	const reasons = reason
		.split(',')
		.map(r => r.trim())
		.filter(Boolean);

	let firstField = null;

	reasons.forEach(singleReason => {
		const findField = REASON_FIELD_MAP[singleReason];
		if (!findField) return;

		const field = findField();
		if (!field) return;

		const formRow = findFormRowForField(field);

		if (formRow && formRow.hasAttribute('data-minimised')) {
			const rowInput = formRow.querySelector('input');
			if (rowInput) {
				expandAndFocusField(formRow);
			}
		}

		highlightUsingExistingStyles(field, formRow);

		if (!firstField) {
			firstField = field;
		}
	});

	// Scroll to and focus the first highlighted field
	if (firstField) {
		if (typeof firstField.scrollIntoView === 'function') {
			firstField.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		if (typeof firstField.focus === 'function') {
			firstField.focus({ preventScroll: true });
		}
	}
}
